export enum DetailsRoutes {
  ENTITY_DETAILS = "entity-details",
  REJECTION_REASON = "rejection-reason",
  RECORD_HISTORY = "record-history",
  RECORD_REVISIONS = "record-revisions",
  APPROVAL_ROUTES = "approval-routes",
  PRINT_VIEW = "print-view",
}
